enum AnalyticsToolName {
  GetBestPractices = 'get-best-practices',
}

export {AnalyticsToolName};
